<template>
  <v-container
    class="ma-0 pa-0"
    oncontextmenu="return false;"
  >
    <v-treeview
      id="direxplorer"
      :active="getCurrentItem"
      :items="items"
      :open="getOpenedDir"
      activatable
      item-key="path"
      dense
      @update:active="itemSelected"
    >
      <template v-slot:label="{ item, open }">
        <div @contextmenu.prevent="showDirContext($event, item)">
          <v-icon>
            {{ open ? "mdi-folder-open" : "mdi-folder" }}
          </v-icon>
          {{ item.name }}
        </div>
      </template>
    </v-treeview>
    <context-menu
      :items="contextItems"
      :position="contextPos"
      :show="contextShow"
      :selected-item="selected"
      @action="contextAction"
    />
  </v-container>
</template>

<script>
// Components
import contextMenu from "./ContextMenu.vue";

// Tools
const ft = require("../Tools/FileTools");

export default {
  components: {
    contextMenu,
  },
  props: {
    rootDir: {
      type: String,
      required: true,
    },
    shareDir: {
      type: String,
      default: "../app/mediacenter/share/",
    },
    currentItem: {
      type: Array,
      default: () => [],
    },
    shareAccess: {
      type: Boolean,
      default: false,
    },
    noContext: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      appRoot: "",
      items: [],
      rootPath: "",
      rootShare: "",
      selected: {},
      contextItems: [],
      contextShow: false,
      contextPos: {
        x: 0,
        y: 0,
      },
    };
  },
  computed: {
    getCurrentItem() {
      let item = this.appRoot + this.$store.state.user.socId;

      if (this.currentItem.length > 0) {
        item = this.currentItem[0].replace("./mediacenter/", this.appRoot);
      }

      return [item];
    },
    getOpenedDir() {
      const openedDir = [];

      if (this.currentItem.length > 0) {
        // Decompose all dirs to open them
        let currentPath = this.currentItem[0].replace("./mediacenter/", this.appRoot);

        let lastIndex = 0;
        let currentRoot = "";
        let currentDir = "";

        while (
          (currentPath.includes(this.rootPath) || currentPath.includes(this.rootShare)) &&
          currentPath != this.rootPath &&
          currentPath != this.rootShare
        ) {
          lastIndex = currentPath.lastIndexOf("/");
          currentRoot = currentPath.slice(0, lastIndex);
          currentDir = currentPath.slice(lastIndex + 1);

          openedDir.push(currentRoot + "/" + currentDir);
          currentPath = currentRoot;
        }
      }

      if (this.currentItem[0].includes("mediacenter/share")) {
        openedDir.push(this.rootShare);
      } else {
        openedDir.push(this.rootPath);
      }

      return openedDir;
    },
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.refresh();
    }

    // Define appRoot using store config
    this.appRoot = this.$store.state.config.dirs.mediacenter;
  },
  methods: {
    itemSelected(val) {
      this.$emit("item-selected", val);
    },
    refresh() {
      ft.scanDir(this.rootDir)
        .then((response) => {
          // Add mediacenter root on response
          this.rootPath = this.rootDir.replace("./mediacenter/", this.appRoot);

          this.items = [
            {
              name: this.$t("navbar.mediacenter"),
              path: this.rootPath,
              type: "dir",
              children: response,
            },
          ];
          // Add share directory in dirExplorer if shareAccess prop true
          if (this.shareAccess) {
            this.refreshShare();
          }
        })
        .catch((err) => {
          // Root dir missing or another error
          console.error("Error on root dir:", err);
        });
    },
    refreshShare() {
      ft.scanDir(this.shareDir)
        .then((response) => {
          // Add share root on response
          this.rootShare = this.shareDir.replace("./mediacenter/", this.appRoot);
          // Unless it already exists
          let shareItemExists = this.items.filter((item) => item.name == this.$t("navbar.share")).length > 0;
          if (!shareItemExists)
            this.items.push({
              name: this.$t("navbar.share"),
              path: this.rootShare,
              type: "dir",
              children: response,
            });
        })
        .catch((err) => {
          // Share dir missing or another error
          console.error("Error on share dir:", err);
        });
    },
    contextAction(item) {
      switch (item.action) {
        case "open":
          this.openDir();
          break;
        case "paste":
          this.pasteToDir();
          break;
        case "rename":
          this.renameDir();
          break;
        case "delete":
          this.deleteDir();
          break;
        default:
          break;
      }
    },
    showDirContext(event, obj) {
      if (obj.path === this.rootPath) {
        return;
      }
      this.selected = obj;
      if (!this.noContext) {
        this.makeDirContext();
        this.showContext(event);
      }
    },
    makeDirContext() {
      this.contextItems = [
        {
          icon: "mdi-open-in-new",
          label: this.$t("project.open"),
          action: "open",
        },
        {
          action: "divider",
        },
        {
          icon: "mdi-content-paste",
          label: this.$t("mediacenter.paste"),
          action: "paste",
        },
        {
          action: "divider",
        },
        {
          icon: "mdi-form-textbox",
          label: this.$t("mediacenter.rename"),
          action: "rename",
        },
        {
          icon: "mdi-delete",
          label: this.$t("mediacenter.delete"),
          action: "delete",
        },
      ];
    },
    showContext(event) {
      event.stopPropagation();
      this.contextShow = false;

      this.$nextTick(() => {
        this.contextPos = {
          x: event.x,
          y: event.y,
        };

        this.contextShow = true;
      });
    },
    openDir() {
      this.itemSelected([this.selected.path]);
    },
    pasteToDir() {
      this.$emit("paste-to-dir", this.selected.path);
    },
    renameDir() {
      this.$emit("rename-dir", this.selected.path);
    },
    deleteDir() {
      this.$emit("delete-dir", this.selected.path);
      //this.itemSelected([this.rootPath]);
    },
  },
};
</script>

<style>
#direxplorer {
  overflow-y: auto;
}

#direxplorer .v-treeview-node {
  cursor: pointer;
}

.theme--dark.v-treeview--hoverable .v-treeview-node__root:hover::before,
.theme--dark#direxplorer .v-treeview-node--click > .v-treeview-node__root:hover::before {
  opacity: 0.05;
}
</style>
